<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">俱乐部介绍</span>
        </div>

        <div class="cardBg">
            <p>
                北京国安足球俱乐部成立于1992年12月29日，是中国大陆成立时间最早的一家职业足球俱乐部。他不仅仅是一支球队，更是一种北京精神。
                作为首都北京的代表，球队一直征战在国内顶级联赛，从联赛草创至今的底蕴积淀与首都北京的沉稳大气相得益彰。
                作为唯一一支常年征战顶级联赛的京城球队，捍卫北京首都的体育文化荣耀，国安当仁不让。
            </p>
            <p>我们热爱北京！<b>We Love Beijing!</b></p>

            <div class="list">
                <dl>
                    <dt>精彩瞬间
                        <Icon type="ios-arrow-dropright"/>
                    </dt>
                    <dd>
                        <carousel :interval="3000" :arrow="'never'" height="16vw" :indicator-position="'none'">
                            <carousel-item v-for="i in imgList.length">
                                <img style="width: 100%" :src="imgList[i-1]" alt="">
                            </carousel-item>
                        </carousel>
                    </dd>
                </dl>
                <dl>
                    <dt>视频资料
                        <Icon type="ios-arrow-dropright"/>
                    </dt>
                    <dd><img src="../assets/img/demoImg/test2.jpg" alt=""></dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "introduce",
    computed: {
        paramsCommandFn() {
            return this.$store.state.lookCommand;
        }
    },
    data() {
        return {
            imgList: [
                require('@/assets/img/moment/1.jpg'),
                require('@/assets/img/moment/2.jpg'),
                require('@/assets/img/moment/3.jpg'),
                require('@/assets/img/moment/4.jpg'),
                require('@/assets/img/moment/5.jpg'),
            ]
        }
    },
    watch: {
        paramsCommandFn: {
            handler(val, old) {
                let routerObj = {};
                let flag = false;
                if (eval('/精彩瞬间/gi').test(val)) {
                    routerObj = {
                        path: '/about/moment',
                        name: 'moment',
                        goType: 1
                    }
                    flag = true;
                } else if (eval('/视频资料/gi').test(val)) {
                    routerObj = {
                        path: '/about/videoClipList',
                        name: 'videoClipList',
                        query: {
                            type: 1, //传参--是俱乐部精彩视频
                        },
                        goType: 1
                    }
                    flag = true;
                }

                if (flag) {
                    this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                    this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                } else {
                    this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                }
            },
            deep: true
        },
    },
    mounted() {
        this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是俱乐部介绍'), true, true, 1);
    },
    methods: {}
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../assets/img/updateImg/head_2.png");
    position: relative;
    font-size: 30px;
    margin-top: 1vw;
}

.cardBg {
    padding: 2vw;
    min-height: calc(100% - 140px);
    box-sizing: border-box;

    p {
        font-family: PingFang;
        font-size: 22px;
        color: rgba(255, 255, 255, .8);
        line-height: 2vw;
        text-indent: 50px;
        letter-spacing: 2px
    }

    .list {
        margin-top: 2vw;

        dl {
            text-align: center;
            font-family: PingFang;
            font-size: 24px;
            color: rgba(255, 255, 255, .8);
            width: 48%;

            &:first-child {
                float: left;
            }

            &:last-child {
                float: right;
            }

            dt {
                height: 3vw;
                line-height: 3vw;
                background-color: rgba(216, 216, 216, .1);
                font-family: PingFangMedium;

                i {
                    font-size: 30px;
                }
            }
        }

        img {
            width: 100%;
        }
    }
}
</style>
